import React from 'react';

import ExportActions from 'exports/ExportActions';
import {WorksheetViewStateType} from 'notebook/worksheets/WorksheetConstants';
import {useValidatedWorksheetContext} from 'notebook/worksheets/WorksheetContext';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';

interface WorksheetExportButtonProps {
  id: string;
  className?: string;
}

export default function WorksheetExportButton(props: WorksheetExportButtonProps): JSX.Element {
  const {worksheetViewState} = useValidatedWorksheetContext();
  const onClick = (): void => {
    ExportActions.requestExportFile(props.id);
  };

  return (
    <Tooltip placement={FloatingPlacement.TOP} text="Export Worksheet">
      <Button
        className={props.className}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        icon="file-export"
        onClick={onClick}
        disabled={worksheetViewState !== WorksheetViewStateType.LOADED}
        size={ButtonSize.MEDIUM}
        dataTestAttrs={{component: 'ExportWorksheetButton', element: 'button'}}
      />
    </Tooltip>
  );
}
